// src/components/player/FloatingMusicPlayer.jsx
import React, { useState, useRef } from 'react';
import { useMusicPlayerStore } from '../../stores/useUIStore'; // 🟢 1. Importamos el store

const FloatingMusicPlayer = () => {
  // 🟢 2. Obtenemos todo el estado y las acciones del store
  const {
    currentTrack,
    isPlaying,
    togglePlay,
    playNext: playNextTrack, // Renombramos para evitar conflicto con la función local
    playPrev: playPreviousTrack,
    hidePlayer,
    progress,
    duration,
    currentTime,
    volume,
    setVolume,
    isMuted,
    toggleMute,
    isPlayerVisible,
  } = useMusicPlayerStore();

  const [showVolumeControl, setShowVolumeControl] = useState(false);
  const progressBarRef = useRef(null);

  // 🟢 3. El reproductor ahora se controla por isPlayerVisible
  if (!currentTrack || !isPlayerVisible) {
    return null;
  }

  const formatTime = (time) => {
    if (isNaN(time) || time === 0) return '0:00';
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60)
      .toString()
      .padStart(2, '0');
    return `${minutes}:${seconds}`;
  };

  const getVolumeIcon = () => {
    if (isMuted || volume === 0) return 'fa-volume-mute';
    if (volume < 0.5) return 'fa-volume-down';
    return 'fa-volume-up';
  };

  return (
    <div className="fixed bottom-4 right-4 bg-white shadow-2xl rounded-lg w-96 p-4 z-[60] animate-fade-in-up">
      <div className="flex items-center space-x-4">
        <img
          src={currentTrack.albumArtUrl}
          alt={currentTrack.title}
          className="w-16 h-16 rounded-md object-cover"
        />
        <div className="flex-1 min-w-0">
          <p className="font-bold text-gray-800 truncate">
            {currentTrack.title}
          </p>
          <p className="text-sm text-gray-500 truncate">
            {currentTrack.artist}
          </p>
          <div className="flex items-center justify-between mt-2">
            <div className="flex items-center space-x-4">
              <button
                onClick={playPreviousTrack}
                className="text-gray-600 hover:text-black"
              >
                <i className="fas fa-step-backward"></i>
              </button>
              <button
                onClick={togglePlay}
                className="text-gray-800 hover:text-blue-600 text-2xl"
              >
                <i
                  className={`fas ${isPlaying ? 'fa-pause-circle' : 'fa-play-circle'}`}
                ></i>
              </button>
              <button
                onClick={playNextTrack}
                className="text-gray-600 hover:text-black"
              >
                <i className="fas fa-step-forward"></i>
              </button>
            </div>
            <div
              className="relative flex items-center"
              onMouseEnter={() => setShowVolumeControl(true)}
              onMouseLeave={() => setShowVolumeControl(false)}
            >
              <button
                onClick={toggleMute}
                className="text-gray-600 hover:text-black w-6 text-center"
              >
                <i className={`fas ${getVolumeIcon()}`}></i>
              </button>
              {showVolumeControl && (
                <input
                  type="range"
                  min="0"
                  max="1"
                  step="0.01"
                  value={isMuted ? 0 : volume}
                  onChange={(e) => setVolume(parseFloat(e.target.value))}
                  className="w-20 ml-2"
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="mt-3">
        <div
          ref={progressBarRef}
          className="w-full bg-gray-200 rounded-full h-1.5 cursor-pointer group"
          onClick={(e) => {
            const clickPosition = e.nativeEvent.offsetX;
            const newTime = (clickPosition / progressBarRef.current.offsetWidth) * duration;
            // La acción de 'seek' ahora se manejaría en el GlobalAudioPlayer
            // Por ahora, esta interacción se deshabilita hasta implementar el 'seek' en el store.
          }}
        >
          <div
            className="bg-blue-600 h-1.5 rounded-full"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
        <div className="flex justify-between text-xs text-gray-500 mt-1">
          <span>{formatTime(currentTime)}</span>
          <span>{formatTime(duration)}</span>
        </div>
      </div>
      <button
        onClick={hidePlayer}
        className="absolute top-2 right-2 text-gray-400 hover:text-gray-700"
      >
        <i className="fas fa-times"></i>
      </button>
    </div>
  );
};

export default FloatingMusicPlayer;
